import React from "react";
import { Link } from "react-router-dom";
import { FaBriefcase, FaAws, FaDocker, FaNodeJs, FaPython, FaMicrosoft, FaGoogle, FaDatabase, FaTerminal, FaWindows, FaLinux, FaServer, FaNetworkWired, FaReact, FaJava, FaGitAlt } from "react-icons/fa";
import { SiTerraform, SiGithubactions, SiJavascript } from "react-icons/si";
import { MdCloud } from "react-icons/md";
import myImg from "../../Assets/soheel.jpg";
import profile from "../../data/profile";

const skillIcons = {
  "AWS (EC2, S3)": <FaAws />,
  "Azure (App & SQL)": <FaMicrosoft />,
  "GCP (Compute & Storage)": <FaGoogle />,
  Docker: <FaDocker />,
  "Terraform / IaC": <SiTerraform />,
  CloudFormation: <MdCloud />,
  "CI/CD": <SiGithubactions />,
  Git: <FaGitAlt />,
  "Bash/Shell": <FaTerminal />,
  "Windows Batch": <FaWindows />,
  Python: <FaPython />,
  JavaScript: <SiJavascript />,
  Java: <FaJava />,
  "Windows Server (2019/2022)": <FaWindows />,
  "Ubuntu / Debian": <FaLinux />,
  "Active Directory & GPO": <FaNetworkWired />,
  "TCP/IP / DNS / DHCP": <FaNetworkWired />,
  "RAID & Virtualization": <FaServer />,
  "MERN Stack": <FaNodeJs />,
  "React.js": <FaReact />,
  "Node.js / Express": <FaNodeJs />,
  "MongoDB/MySQL": <FaDatabase />,
};

function Sidebar() {
  const b = profile.basics;
  return (
    <div className="glass-card profile-sidebar">
      <div className="profile-header">
        <div className="avatar">
          <img src={myImg} alt={`${b.name} avatar`} />
        </div>
        <h1>Soheel M. Gadad</h1>
        <p>{b.role}</p>
      </div>

      <ul className="contact-list">
        <li><FaBriefcase /> {b.experience}</li>
      </ul>

      <hr className="sidebar-divider" />

      {profile.skills.map((cat) => (
        <div className="skill-category" key={cat.category}>
          <h3>{cat.category}</h3>
          <div className="tags">
            {cat.items.map((item) => (
              <span className="tag" key={item}>
                {skillIcons[item]}
                {item}
              </span>
            ))}
          </div>
        </div>
      ))}

      <div className="sidebar-download">
        <Link to="/resume" className="btn btn-primary">
          Download Resume
        </Link>
      </div>
    </div>
  );
}

export default Sidebar;